// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"a22ec1e8","381":"850ce49f","526":"e56f3ca9","634":"2ea96a6b"}[chunkId] + ".css";
};